import { default as balance } from './balance/routes'

export default [
    ...balance,
]

